import React from 'react';
import { Link } from './Link';
import styled from '@emotion/styled';

const MenuItemLink = styled(Link)`
    color: ${({ theme }) => theme.text.color.primary};
    font-weight: 400;
    display: block;
    padding: 12px 10px 12px 44px;
    margin-left: 10%;
`;

export function SubNavigationItem(props: any) {
    const { targetUrl, title } = props;
    return (
        <li>
            <MenuItemLink href={targetUrl}>
                <span dangerouslySetInnerHTML={{ __html: title }} />
            </MenuItemLink>
        </li>
    );
}
